/* loaded by smart-asset */
export default require("./info-circle-solid~FXmXXETu.svg")